import { locutusGetAllPlansApi } from 'api-validations/locutus'
import { useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { useApiClient, useQuery } from 'shared-ui/api-provider'

export const queryKey = 'get-all-plans'

/**
 * Query for getting all plans for an operation, grouped by field ID
 */
export const useAllPlans = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useQuery({
    queryKey: [queryKey, orgCode],
    queryFn: async () => {
      const response = await apiClient.get(locutusGetAllPlansApi.pathFor({ orgCode }))

      return locutusGetAllPlansApi.responseSchema.parse(response.body)
    }
  })
}
